import './Badges.scss'
import React from 'react'
import DynamicPricingIcon from 'common/views/components/DynamicPricingIcon/DynamicPricingIcon'

export const Badges = ({className, tags}) => {
  return (
    <div className={`Badges ${className || ''}`}>
      {tags.map(({ type }) => <DynamicPricingIcon key={type} type={type} style={{ marginRight: 5 }} />)}
    </div>
  )
}
